export default "__VITE_ASSET__lIbaWj6Z__"